module.exports = __webpack_public_path__ + "static/media/sun_rise.dee153bf.png";